@if (formAdded) {
  <div [formGroup]="form">
    <app-material-select2
      [formControlName]="field_name"
      [require]="require"
      [caption]="caption"
      [multiple]="multiple">
      <ng-content></ng-content>
    </app-material-select2>
  </div>
}
